// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__iICw7","row":"Footer_row__-tc1Y"};